import { Box, Stack } from "@mui/material";
import { Outlet } from "react-router-dom";

export function AuthLayout() {
  return (
    <Box backgroundColor="#f8f8fa" height="100vh">
      <Stack
        alignItems="center"
        justifyContent="center"
        height="100%"
        spacing={2}
      >
        <Outlet />
      </Stack>
    </Box>
  );
}
